import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Role } from "../model/User";
import Header from "./Header";
import { Dashboard } from "../../dashboard/DashboardPage";
import { ForgotPage } from "../../login/ForgotPage";
import LoginPage from "../../login/LoginPage";
import { ResetPasswordPage } from "../../login/ResetPasswordPage";
import SignUpPage from "../../login/SignUpPage";
import { ProfessionnelPage } from "../../professionnels/ProfessionnelPage";
import { ProfilPage } from "../../profil/ProfilPage";
import { LegacyPage } from "../../legacy/LegacyPage";
import { SearchPage } from "../../search/SearchPage";
import { ProjectDetailsPage } from "../../structures/ProjectDetailsPage";
import { ProjectPage } from "../../structures/ProjectPage";
import { RouteApp } from "../model/RouteApp";
import { NotFoundPage } from "./NotFoundPage";
import PrivateRoute from "./PrivateRoute";
import { ManageProjectsPage } from "../../projects/ManageProjectsPage";
import Footer from "./Footer";
import MissionBrowsePage from "../../missions/MissionBrowsePage";
import { MissionProCard } from "../../missions/components/MissionProCard";
import { MissionStructCard } from "../../missions/components/MissionStructCard";
import { PublicProjectDetails } from "../../projects/PublicProjectDetails";
import { NotificationProjectPage } from "../../search/NotificationProjectPage";
import NotificationMissionPage from "../../missions/NotificationMissionPage";
import ManageDocumentsPage from "../../documents/ManageDocumentsPage";

const MainRoutes: FunctionComponent = () => {
    return (
        <>
            <Header />
            <Routes>
                <>
                    <Route
                        path={"/"}
                        element={<Navigate to={RouteApp.LOGIN} />}
                    ></Route>
                    <Route path={RouteApp.LOGIN} element={<LoginPage />} />
                    <Route path={RouteApp.SIGNUP} element={<SignUpPage />} />
                    <Route
                        path={RouteApp.FORGOT_PASSWORD}
                        element={<ForgotPage />}
                    />
                    <Route
                        path={RouteApp.RESET_PASSWORD}
                        element={<ResetPasswordPage />}
                    />
                    <Route
                        path={RouteApp.PUBLIC_PROJECT_DETAILS}
                        element={<PublicProjectDetails />}
                    />
                </>

                <Route
                    index
                    path={RouteApp.DASHBOARD}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.PROFESSIONNELS}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <ProfessionnelPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.SEARCH}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <SearchPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.MY_PROJECTS}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <ProjectPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.MANAGE_PROJECTS}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <ManageProjectsPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.MISSION_BROWSER}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <MissionBrowsePage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.MISSION_DETAILS_PRO}
                    element={
                        <PrivateRoute roles={[Role.User, Role.Professionnel]}>
                            <MissionProCard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.MISSION_DETAILS_STR}
                    element={
                        <PrivateRoute roles={[Role.User, Role.Structure]}>
                            <MissionStructCard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.MY_PROJECTS_DETAILS + "/:idProject"}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <ProjectDetailsPage />
                        </PrivateRoute>
                    }
                />

                <Route
                    path={RouteApp.MY_ACCOUNT}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <ProfilPage />
                        </PrivateRoute>
                    }
                />
                {
                    <Route
                        path={RouteApp.LEGACY}
                        element={<LegacyPage />}
                    ></Route>
                }
                {<Route path="*" element={<NotFoundPage />}></Route>}
                <Route
                    path={RouteApp.NOTIFICATION_DISPONIBILITE_STRUCTURE}
                    element={
                        <PrivateRoute roles={[Role.User, Role.Professionnel]}>
                            <NotificationProjectPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.NOTIFICATION_MISSION}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Professionnel,
                                Role.Structure,
                            ]}
                        >
                            <NotificationMissionPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={RouteApp.DOCUMENTS_MANAGEMENT}
                    element={
                        <PrivateRoute
                            roles={[
                                Role.User,
                                Role.Structure,
                                Role.Professionnel,
                            ]}
                        >
                            <ManageDocumentsPage />
                        </PrivateRoute>
                    }
                />
            </Routes>
            <Footer />
        </>
    );
};

export default MainRoutes;
